/* eslint-disable react-hooks/exhaustive-deps */
import { Link, Flex } from '@tonic-one/react';
import EditConditionalAccessPolicyModal from './Modal';
import React, { useState } from 'react';

const ConditionalAccessPolicyNameCell = React.memo(
  (policy: {
    policyName: string;
    action: string;
    users: {
      userId: string;
      userName: string;
      userPrincipalName: string;
    }[];
    id: string;
    [key: string]: any;
    setRefreshTrigger: (date: Date) => void;
  }) => {
    const onClose = () => {
      setIsVisible(false);
    };
    const [isVisible, setIsVisible] = useState(false);
    return (
      <Link
        maxWidth="100%"
        onClick={() => {
          setIsVisible(true);
        }}
      >
        <EditConditionalAccessPolicyModal
          isVisible={isVisible}
          onClose={onClose}
          data={policy}
          setRefreshTrigger={policy.setRefreshTrigger}
        ></EditConditionalAccessPolicyModal>
        <Flex>{policy.policyName}</Flex>
      </Link>
    );
  }
);
export default ConditionalAccessPolicyNameCell;
